import { useEffect } from 'react'

export interface PrivacyPolicyProps {}

export const usePrivacyPolicy = (props: PrivacyPolicyProps) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return {
    ...props,
  }
}
